import { z } from 'zod';
import { id, paginatedResult, paginationQuery } from './common.js';

export const favoritePracticeInput = z
  .object({
    favorite: z.boolean(),
    expectedRevision: z.number().int().nonnegative(),
    clientRequestId: z.string().uuid(),
  })
  .strict();
export type FavoritePracticeInput = z.infer<typeof favoritePracticeInput>;
export const favoritePracticeState = z.object({
  locationId: id,
  favorite: z.boolean(),
  revision: z.number().int().nonnegative(),
  canFavorite: z.boolean(),
  unavailableReason: z.string().nullable(),
});
export type FavoritePracticeState = z.infer<typeof favoritePracticeState>;
export const favoritePracticeStates = z.object({
  canWrite: z.boolean(),
  items: z.array(favoritePracticeState),
});
export type FavoritePracticeStates = z.infer<typeof favoritePracticeStates>;
export const favoritePracticeQuery = paginationQuery
  .extend({
    search: z.string().trim().max(100).optional(),
    availability: z.enum(['all', 'available', 'unavailable']).default('all'),
  })
  .strict();
export type FavoritePracticeQuery = z.infer<typeof favoritePracticeQuery>;
export const favoriteLocationIds = z
  .array(id.max(200))
  .max(100)
  .refine((ids) => new Set(ids).size === ids.length, 'Choose each location only once.');
export const favoritePractice = favoritePracticeState.extend({
  name: z.string(),
  groupName: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  timezone: z.string().nullable(),
  available: z.boolean(),
  savedAt: z.string(),
});
export type FavoritePractice = z.infer<typeof favoritePractice>;
export const favoritePracticePage = paginatedResult(favoritePractice).extend({
  canWrite: z.boolean(),
});
export type FavoritePracticePage = z.infer<typeof favoritePracticePage>;
